import React, { useEffect } from "react";
import db from "../articles.json";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Wrapper from "../components/Wrapper/Wrapper";
import { Helmet } from "react-helmet";
import ArticlePost from "../components/Articles/ArticlePost";

import classes from "./Public.module.css";

const Public = () => {

    /* scroll to top on page load */
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Wrapper background="rgb(240, 240, 240)">
            <Helmet>
                <title>Pro veřejnost</title>
            </Helmet>
            <Breadcrumbs />
            <h1 className={classes.headline}>Články pro veřejnost</h1>
            <div className={classes.wrapper}>
                {db.map((item: any) => <ArticlePost postsToRender={item} />)}
            </div>
        </Wrapper>
    )
};

export default Public;
